/**
 * Integration Dashboard Page
 * Main page for system integration and unified service management
 */

import React from 'react';
import IntegrationDashboard from '../../components/integration/IntegrationDashboard';

const IntegrationDashboardPage = () => {
  return (
    <div>
      <IntegrationDashboard />
    </div>
  );
};

export default IntegrationDashboardPage;
